"use strict";
// ATTENTION: DO NOT ADD REQUIRED() FLAG TO CLAIM SCHEMA
// Required fields are enforced at the end of claim-schema.ts `const submittedClaimSchema = claimSchema.options({ presence: 'required' });`
// This will ensure that all fields not explicitly marked as optional() are required
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.borrowerCharges = void 0;
var claim_domain_1 = require("@hobt/claim-domain");
var constants_1 = require("@hobt/constants");
var utils_1 = require("@hobt/utils");
var Joi = require('joi').extend(require('@joi/date'));
exports.borrowerCharges = Joi.object({
    amount: Joi.number()
        .min(-9999999999999.99)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false }),
    code: (_a = Joi.string()
        .required()).valid.apply(_a, Object.values(claim_domain_1.BorrowerChargesCode)),
    comment: Joi.string()
        .min(1)
        .max(40)
        .optional()
        .when('code', {
        is: claim_domain_1.BorrowerChargesCode.Other,
        then: Joi.required(),
        otherwise: Joi.optional().allow(''),
    }),
    datePaid: Joi.date()
        .less(utils_1.getCurrentDate())
        .rule({
        message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_STRICTLY_PAST_DATE, 'Date Paid'),
    }),
});
exports.default = { borrowerCharges: exports.borrowerCharges };
